import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=e3881bc6&scoped=true&"
import script from "./PostEditor.vue?vue&type=script&lang=js&"
export * from "./PostEditor.vue?vue&type=script&lang=js&"
import style0 from "./PostEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PostEditor.vue?vue&type=style&index=1&id=e3881bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3881bc6",
  null
  
)

export default component.exports